// 화면 19 (Stock Score Explorer) REST 어댑터.
// 권위: docs/ARCH_DASHBOARD.md v1.10.3 §6.2 — 4 엔드포인트.
// 응답 envelope 은 client.ts interceptor 가 언랩.

import { apiGet } from '../../api/client';
import type {
  BandsDistribution,
  PercentileHistogram,
  ScoreHistory,
  StockSearchResult,
} from './types';

export async function searchStocks(q: string, limit = 20): Promise<StockSearchResult> {
  const qs = new URLSearchParams({ q, limit: String(limit) }).toString();
  return apiGet<StockSearchResult>(`/api/v1/stocks/search?${qs}`);
}

export async function getScoreHistory(symbol: string, days = 90): Promise<ScoreHistory> {
  const qs = new URLSearchParams({ days: String(days) }).toString();
  return apiGet<ScoreHistory>(`/api/v1/stocks/${symbol}/score-history?${qs}`);
}

export async function getBandsDistribution(days = 60): Promise<BandsDistribution> {
  const qs = new URLSearchParams({ days: String(days) }).toString();
  return apiGet<BandsDistribution>(`/api/v1/stocks/score-distribution/bands?${qs}`);
}

// date 가 null 이면 미전송 → 서버가 max(trading_date) 폴백 (Phase B `/daily` 패턴 따라).
export async function getPercentileHistogram(
  date: string | null,
  bins = 10
): Promise<PercentileHistogram> {
  const params: Record<string, string> = { bins: String(bins) };
  if (date) params.date = date;
  const qs = new URLSearchParams(params).toString();
  return apiGet<PercentileHistogram>(`/api/v1/stocks/score-distribution/percentile?${qs}`);
}
